/* RESPONSIBLE TEAM: team-messenger */

import Model, { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';

export default class IdvSetting extends Model {
  @service declare intl: any;

  @attr('string') declare name: string;
  @attr('string') declare secret: string;
  @attr('boolean') declare supportsAndroid: boolean;
  @attr('boolean') declare supportsIos: boolean;
  @attr('boolean') declare supportsWeb: boolean;
  @attr('boolean') declare deleted: boolean;
  @attr('date') declare createdAt: Date;
  @attr('number') declare lastUsedAt: number;

  get formattedLastUsedAt() {
    if (this.lastUsedAt == null) {
      return null;
    }
    return this.intl.formatDate(this.lastUsedAt * 1000, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
  }
}
